import { create } from 'zustand'
import { User } from '../helpers/types/user'
import { fetchUsers } from '../api/user'

export interface UserState {
	users: User[]

	fetchUsers: () => Promise<void>
	addUser: () => void
	createUser: (user: User) => void
}

export const userStore = create<UserState>((set) => ({
	users: [],

	fetchUsers: async () => {
		if (userStore.getState().users.length) return
		const users = await fetchUsers()
		set({ users })
	},

	addUser: async () => {
		const user: User = {
			id: '1',
			firstName: 'Иван',
			lastName: 'Иванов',
			middleName: 'Иванович',
			position: 'Инженер',
			role: 'Пользователь',
			phone: '+998901234567',
			username: 'ivanov',
			createdAt: new Date().toISOString(),
			lastSeen: new Date().toISOString(),
			isDeleted: false
		}

		set((state) => ({ users: [user, ...state.users] }))
	},

	createUser: async (user) => {
		set((state) => ({ users: [user, ...state.users] }))
	}
}))
